import { render, staticRenderFns } from "./PurchaseHero.vue?vue&type=template&id=0a2e40b2&scoped=true&"
import script from "./PurchaseHero.vue?vue&type=script&lang=js&"
export * from "./PurchaseHero.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseHero.vue?vue&type=style&index=0&id=0a2e40b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e40b2",
  null
  
)

export default component.exports